import { AlertTriangle, RotateCw } from "lucide-react";
import { Button } from "@/components/ui/button";

type PortalErrorFallbackProps = {
  message?: string;
  onReload?: () => void;
};

const PortalErrorFallback = ({
  message = "We couldn't load this content. Please try again.",
  onReload,
}: PortalErrorFallbackProps) => {
  const handleReload = () => {
    if (onReload) onReload();
    else window.location.reload();
  };

  return (
    <div className="flex flex-col items-center justify-center text-center py-20 px-6">
      <div className="w-12 h-12 rounded-full bg-(--color-danger-50) flex items-center justify-center mb-4">
        <AlertTriangle className="w-6 h-6 text-(--color-danger-500)" />
      </div>
      <h2 className="text-lg font-semibold text-(--color-text-primary)">
        Something went wrong
      </h2>
      <p className="mt-1 text-sm text-(--color-text-secondary) max-w-sm">
        {message}
      </p>
      <Button className="mt-5" onClick={handleReload}>
        <RotateCw className="w-4 h-4" />
        Reload
      </Button>
    </div>
  );
};

export default PortalErrorFallback;
